if (!customElements.get('sticky-button')) {
  customElements.define(
    'sticky-button',
    class StickyButton extends HTMLElement {
      constructor() {
        super();
        this.cartButton = this.querySelector('[data-link-add-to-cart]');
      }

      connectedCallback() {
        const el = this;
        const scrollAt = this.dataset.scroll / 100

        window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        const scrollProgress = (scrollTop + viewportHeight) / pageHeight;

            if (scrollProgress >= scrollAt ) {
                el.classList.add('is-sticky');
            }else{
               el.classList.remove('is-sticky'); 
            }
        });

        if(this.cartButton){
          this.cartButton.addEventListener('click', () => {
                    
            const formBtn = document.querySelector('form.product-single__form button[type="submit"]');
            formBtn?.click();
          })
        }

        
      }
    }
  );
}
